import { createFileRoute, useParams } from "@tanstack/react-router";
import { CaseDetailPage } from "@/components/crm/CaseDetailPage";

export const Route = createFileRoute("/user/_layout/crm/cases_/$id")({
  component: UserCaseDetail,
});

function UserCaseDetail() {
  const { id } = useParams({ from: "/user/_layout/crm/cases_/$id" });
  return <CaseDetailPage caseId={id} role="user" />;
}
